import classNames from "classnames";

import { useState } from "react";

import ArrowRight from "assets/iconsv2/arrow-right-16.svg";
import ArrowLeft from "assets/iconsv2/arrow-left-16.svg";

import SectionHeader from "./SectionHeader";

import styles from "./HiringProcess.module.css";

import type { MouseEventHandler } from "react";

const steps = [
  {
    title: "Send an engaging email",
    description: `
      Tell us why you want to join Raycast and why you generally care about the problem we're solving.

      Make your first impression count. Share with us what excites you and how you envision your role at Raycast, what we’re missing, and pack your intro with the amazing work you’ve done.
    `,
  },
  {
    title: "Founders intro",
    description: `
      Chat with a founder to get to know what it takes to work at Raycast.

      Come prepared to the meeting. It's a way for both sides to get to know each other. Good candidates prepare questions, used our app and articulate what they look for in their next role.
    `,
  },
  {
    title: "Take-home task",
    description: `
      You will meet a team member that you'll work with together later. They will brief you on a take-home task.

      This step is the moment to shine. We open a Slack chat to communicate – use it! Most candidates go silent and come back with bad results. We collaborate with you on the task to simulate real work.
    `,
  },
  {
    title: "Task presentation",
    description: `
      You will present us the results of your take-home task.

      Don't spend time preparing a slideshow, instead articulate your thinking. Why did you take a shortcut? What would you do differently when you had more time? What little detail did you add?
    `,
  },
  {
    title: "Offer Stage",
    description: `
      We wrap it up with an offer and discuss the final details.

        We're very transparent throughout our interview process. There shouldn't be any surprises at this step. We align on the last bits before we make you part of the RayFam.
    `,
  },
];

const HiringProcess = () => {
  const [selectedStep, setSelectedStep] = useState<number>(0);
  const nextStep: MouseEventHandler = (event) => {
    event.preventDefault();
    setSelectedStep((selectedStep + 1) % steps.length);
  };

  const prevStep: MouseEventHandler = (event) => {
    event.preventDefault();
    setSelectedStep(selectedStep - 1 >= 0 ? selectedStep - 1 : steps.length - 1);
  };

  return (
    <div className={styles.hiringProcess}>
      <SectionHeader title="Hiring process" anchor="hiring-process">
        Take a look at our interview steps, and a few tips to make your hiring experience great.
      </SectionHeader>

      <div className={styles.steps}>
        <div className={styles.mobileNav}>
          <a className={classNames(styles.mobileNavLink, styles.prev)} onClick={prevStep}>
            <ArrowLeft className="icon" />
          </a>
          <a className={classNames(styles.mobileNavLink, styles.next)} onClick={nextStep}>
            <ArrowRight className="icon" />
          </a>
        </div>
        {steps.map((step, index) => (
          <div
            key={step.title}
            className={classNames(styles.step, { [styles.selected]: index === selectedStep })}
            onMouseEnter={() => setSelectedStep(index)}
            onClick={() => setSelectedStep(index)}
          >
            <div className={styles.stepTitle}>{step.title}</div>
            <div className={styles.stepNumber}>{index + 1}</div>
            <div className={styles.tip}>
              <strong>Tips</strong>
              {step.description.split("\n\n").map((paragraph, paragraphIndex) => (
                <p key={paragraphIndex}>{paragraph}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HiringProcess;
